{
  "organizationLabel": "조직:",
  "profileDropdownAccountInfoItem": "계정 정보 (내부)",
  "profileDropdownAccountSettingsHeader": "계정 설정",
  "profileDropdownProductSettingsHeader": "제품 설정",
  "profileDropdownUserSettingsItem": "환경 설정",
  "profileLegalNoticesMenuItem": "법적 고지 사항",
  "signOut": "로그아웃",
  "themeInfoTooltip": "일부 애플리케이션은 어두운 테마를 지원하지 않습니다.",
  "userProfileName": "{lastName} {firstName}",
  "userThemeSwitchLabel": "어두운 테마"
}
